import { colors } from '../../Colors/colors'

export const searchAndMonitoringTheme = {
   light: {
      common: {
         titleColor: 'text-gray-700'
      },
      filters: {
         addFilters: {
            filterButtonTextColor: 'text-primary-600',
            filterButtonIconColor: colors['primary-600'],
            filterButtonBorderColor: '!border-primary-600'
         },
         cancelFilters: {
            filterButtonTextColor: 'text-gray-600',
            filterButtonIconColor: colors['gray-600'],
            filterButtonBorderColor: 'border-gray-300'
         },

         filterButtonColors: 'bg-base-white',
         textColor: 'text-gray-700'
      },
      filtersView: {
         titleColors: 'text-gray-700',
         descriptionColors: 'text-gray-600',
         infoTextColors: 'text-gray-500'
      },
      filterConditionPills: {
         iconColors: colors['primary-600'],
         propertyIconColor: colors['primary-600'],
         tooltipArrowColor: colors['gray-900']
      },
      filtersSidePane: {
         defaultBorderColor: 'border-gray-300',
         textColor: 'text-gray-700',
         filterIconStrokeColor: colors['primary-500']
      },
      applicationsList: {
         propertyIconColor: colors['gray-600']
      }
   },
   dark: {}
}
